import KeenSlider from "keen-slider";

let dots;
let slides;
let slider;

const navigation = (sldr) => {
  slider = sldr;
  //
	dots.forEach((el, i) => (el.dataset.index = i));
	dots[0].dataset.active = true;
  //
  imgs = document.querySelectorAll(".main-product__image img");
  //
  slides = document.querySelectorAll(
    ".main-product__carousel__image.keen-slider__slide"
  );
  slides[0].dataset.active = true;
	//
	const leftBtn = document.querySelector(
		".main-product__carousel .slider-controls .circle-arrow-btn[data-dir=left]"
	);
	const altLeftBtn = document.querySelector(
		".main-product__carousel .circle-arrow-btn[data-dir=left]"
	);
	const rightBtn = document.querySelector(
		".main-product__carousel .slider-controls .circle-arrow-btn[data-dir=right]"
	);
	const altRightBtn = document.querySelector(
		".main-product__carousel .circle-arrow-btn[data-dir=right]"
	);
	//
	leftBtn.addEventListener("click", slider.prev);
	altLeftBtn.addEventListener("click", slider.prev);
	rightBtn.addEventListener("click", slider.next);
	altRightBtn.addEventListener("click", slider.next);
  slides.forEach((s) => s.addEventListener('click', onSlideClick))
	slider.on("slideChanged", update);
};

const update = (e) => {
	dots.forEach((el) => (el.dataset.active = false));
	dots[e.track.details.rel].dataset.active = true;
  slides.forEach((el) => (el.dataset.active = false));
	slides[e.track.details.rel].dataset.active = true;
  imgs.forEach((el) => (el.dataset.active = false));
	imgs[e.track.details.rel].dataset.active = true;
};

const onSlideClick = (e) => {
  let index;
  slides.forEach((el, i) => {
    if (e.target === el) {
      el.dataset.active = true;
      index = i;
    } else {
      el.dataset.active = false;
    }
  });
  //
  imgs.forEach((el) => (el.dataset.active = false));
	imgs[index].dataset.active = true;
  slider.moveToIdx(index);
};

const initSlider = () => {
  const length = dots.length;
  const bp1 = length > 1 ?
        {
          slides: {
            perView: 2,
            spacing: 8,
          }
        } : { disabled: true };
  const bp2 = length > 3 ?
        {
          slides: {
            perView: 3,
            spacing: 8,
          }
        } : { disabled: true };
  const bp3 = length > 4 ?
        {
          slides: {
            perView: 4,
            spacing: 20,
          }
        } : { disabled: true };

  new KeenSlider(
    ".main-product__carousel__images",
    {
      loop: true,
      slides: {
        perView: 1,
        spacing: 0,
      },
      breakpoints: {
        "(min-width: 720px)": bp1,
        "(min-width: 960px)": bp2,
        "(min-width: 1220px)": bp3,
      },
    },
    [navigation]
  );
}

export default function () {
	if (document.querySelector(".main-product__carousel__images")) {
    dots = document.querySelectorAll(
      ".main-product__carousel .slider-controls__dot"
    );
    initSlider();
	}
}
